import { Locale } from 'enums/locale';

export function getLocalePrefix(locale: Locale) {
  return locale === Locale.TR ? '/' : `/${locale}/`;
}
